import { useEffect } from 'react';
import HeaderStyleTwo from '../Shared/HeaderStyleTwo';
import Footer from '../Shared/Footer';
import VolunteersBanner from '../Shared/VolunteersBanner';
import Facts from '../Shared/Facts';
import * as React from 'react';
import { styled } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props: {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}) {
  const { children, onClose, ...other } = props;
  return (
    <DialogTitle {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          style={{ position: 'absolute', right: 8 }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}
const GetInvolved = () => {
  const [openZelle, setOpenZelle] = React.useState(false);
  const [openVenmo, setOpenVenmo] = React.useState(false);

  useEffect(() => {
    runJQueryScripts();
  }, []);

  const runJQueryScripts = () => {
    let tag: any;
    let loadScript = function (src: string) {
      tag = document.createElement('script');
      tag.async = false;
      tag.src = src;
      document.getElementsByTagName('body')[0].appendChild(tag);
    };
    loadScript('../assets/js/jquery.js');
    loadScript('../assets/js/popper.min.js');
    loadScript('../assets/js/jquery-ui.js');
    loadScript('../assets/js/jquery.fancybox.js');
    loadScript('../assets/js/owl.js');
    loadScript('../assets/js/appear.js');
    loadScript('../assets/js/wow.js');
    loadScript('../assets/js/lazyload.js');
    loadScript('../assets/js/scrollbar.js');
    loadScript('../assets/js/script.js');
    return () => {
      document.getElementsByTagName('body')[0].removeChild(tag);
    };
  };
  return (
    <>
      <HeaderStyleTwo />
      {/* <section className="page-banner">
                <div className="image-layer lazy-image" data-bg="url('assets/images/background/bg-banner-1.jpg')"></div>
                <div className="bottom-rotten-curve alternate"></div>
                <div className="auto-container">
                    <h1>About Us</h1>
                    <ul className="bread-crumb clearfix">
                        <li><a href="/">Home</a></li>
                        <li className="active">About Us</li>
                    </ul>
                </div>
            </section> */}
      <div className="ulockd-inner-page">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="ulockd-icd-layer">
                <ul className="list-inline ulockd-icd-sub-menu">
                  <li>
                    <a style={{ color: '#25283a' }} href="/">
                      {' '}
                      Home{' '}
                    </a>
                  </li>
                  <li>
                    <a style={{ color: '#25283a' }} href="#">
                      <b> / </b>
                    </a>
                  </li>
                  <li>
                    {' '}
                    <a href="/get-involved"> Donation</a>{' '}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="about-section style-two alternate">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="left-column col-lg-6 col-md-12 col-sm-12">
              <div className="inner">
                <div className="sec-title">
                  {/* <div className="sub-title">About Us</div> */}
                  <h3>MAKE A DONATION</h3>
                  <div className="text">
                    <p>
                      <b>No one has ever become poor by giving</b>
                    </p>
                    <p>
                      Invest your money to gain pleasure of ALLAH.
                      {/* 100% of donations given to Sadqa-E-Jariya Welfare Foundation, will go to the needy. There is no administrative fee.  */}
                      <br />
                      Your Sadaqah and Zakat will save you from Hellfire.
                    </p>

                    <p>
                      Please donate generously. Your donation will be a 501c
                      tax-deductible.
                    </p>
                    <div className="clearfix">
                      <div className="donation-button">
                        <a
                          href="/get-involved/donate"
                          className="theme-btn btn-style-one"
                        >
                          <span className="btn-title">
                            Donate Via Credit/Debit Card
                          </span>
                        </a>
                      </div>

                      {/* <a href="/get-involved" className="theme-btn btn-style-one"><span className="btn-title">Join Us Now</span></a> */}
                      <div className="donation-button">
                        <form
                          action="https://www.paypal.com/cgi-bin/webscr"
                          method="post"
                          target="_blank"
                        >
                          <input type="hidden" name="cmd" value="_s-xclick" />
                          <input
                            type="hidden"
                            name="hosted_button_id"
                            value="7MKGVM37HHTC6"
                          />
                          <button
                            type="submit"
                            className="theme-btn btn-style-three"
                            name="submit"
                            title="PayPal - The safer, easier way to pay online!"
                          >
                            <span className="btn-title">Donate Via PayPal</span>
                          </button>
                        </form>
                      </div>

                      {/* Donation Buttons */}
                      <div className="donation-button">
                        <button
                          className="theme-btn btn-style-one"
                          onClick={() => setOpenZelle(true)}
                        >
                          <span className="btn-title">Donate via Zelle</span>
                        </button>
                      </div>

                      <div className="donation-button">
                        <button
                          className="theme-btn btn-style-three"
                          onClick={() => setOpenVenmo(true)}
                        >
                          <span className="btn-title">Donate via Venmo</span>
                        </button>
                      </div>
                    </div>
                    <p></p>
                    <p>
                      <strong>
                        You can also donate directly into our bank account:
                      </strong>
                    </p>
                    <ul>
                      <li>
                        <strong>USA</strong>
                      </li>
                      <li>
                        <strong>Name of the Bank:</strong> Bank of America
                        American Muslim Youth Leasership DBA Sadqa Jariya
                        Welfare Foundation
                      </li>
                      <li>
                        <strong>Account #:</strong> 8981 0408 0002
                      </li>
                      <li>
                        <strong>Checks can be mailed to:</strong> 10407 Emerald
                        Woods Ave Orlando, FL 32836
                      </li>
                    </ul>
                    <br />
                    <ul>
                      <li>
                        <strong>Pakistan</strong>
                      </li>
                      <li>
                        <strong>Name of the Bank:</strong> Habib Metropolitan
                        Bank Ltd IBB Khayaban-E-Jami Branch Karachi
                      </li>
                      <li>
                        <strong>Title of Account:</strong> Sadqa-E-Jariya
                        Welfare Foundation
                      </li>
                      <li>
                        <strong>Account #:</strong> 6-99-17-29301-714-109752
                      </li>
                      <li>
                        <strong>IBAN #:</strong> PK16 MPBL 9917 1771 4010 9752
                      </li>
                    </ul>
                    <br />
                  </div>
                </div>
              </div>
            </div>
            <div className="right-column col-lg-6 col-md-12 col-sm-12">
              <div className="inner">
                <div
                  className="image wow fadeInLeft animated"
                  data-wow-delay="0ms"
                  style={{
                    visibility: 'visible',
                    animationDelay: '0ms',
                    animationName: 'fadeInLeft',
                  }}
                >
                  <img
                    className="lazy-image loaded"
                    style={{ borderRadius: 20 }}
                    src="assets/images/resource/image-spacer-for-validation.png"
                    data-src="assets/images/resource/sadqajariya-make-a-donation.jpg"
                    alt=""
                  />
                  <p>
                    "Surely those men who give sadaqah (alms) and those women
                    who give sadaqah and have advanced a good loan to Allah, for
                    them it will be multiplied, and for them is a noble reward."
                    Surah Al-Hadid [57:18]
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />

      {/* Zelle Modal */}
      <BootstrapDialog
        onClose={() => setOpenZelle(false)}
        aria-labelledby="zelle-dialog-title"
        open={openZelle}
      >
        <BootstrapDialogTitle
          id="zelle-dialog-title"
          onClose={() => setOpenZelle(false)}
        >
          Donate via Zelle
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            Please send your Zelle donation to: <b>shoaib100@yahoo.com</b>
          </Typography>
          <Typography>
            Include your name and purpose in the memo for tracking.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={() => setOpenZelle(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </BootstrapDialog>

      {/* Venmo Modal */}
      <BootstrapDialog
        onClose={() => setOpenVenmo(false)}
        aria-labelledby="venmo-dialog-title"
        open={openVenmo}
      >
        <BootstrapDialogTitle
          id="venmo-dialog-title"
          onClose={() => setOpenVenmo(false)}
        >
          Donate via Venmo
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            Please send your Venmo donation to: <b>shoaib100@yahoo.com</b>
          </Typography>
          <Typography>
            Mention the donation purpose in the transaction note.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={() => setOpenVenmo(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </>
  );
};
export default GetInvolved;
